module.exports = __webpack_public_path__ + "static/media/cc-jcb.579a4adb.svg";